import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Fab from '@mui/material/Fab';
import { LinearProgress, Tooltip } from '@mui/material';
import TerritoryAreaModal from '../../AddOrUpdate/components/TerritoryAreaModal';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import { showNotification } from 'src/shared/components/Notification';

const TerritoryRegionsListView = ({ }) => {
    const { regionId } = useParams();
    useEffect(() => {
        getAllTerritoryRegionAreaDetails();

    }, []);
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: true,
        withPagination: true,
        withSearchEngine: true,
        manualPageSize: [10, 50, 100, 1000],
        placeholder: 'Search by Territory Name ...',
    };
    const [isRedirect, setIsRedirect] = useState(false);
    const { t } = useTranslation('common');
    const [reactTableData, setReactTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isTitle, setTitle] = useState(null);
    const [isNoRecordFound, setNoRecordFound] = useState(false);
    const [viewDetailPopup, setViewDetailPopup] = useState(false);

    const back = () => {
        setIsRedirect(true);
    }
    const columns = useMemo(
        () => [
            {
                Header: '#',
                accessor: (row, i) => i + 1, // Or just use Cell below for more control
                disableGlobalFilter: true,
                disableSortBy: true,
                width: 2,
                Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
            },
            {
                Header: 'Territory Code',
                accessor: 'regionInfo.regionCode',
                disableGlobalFilter: false,
            },
            {
                Header: 'Territory Name',
                accessor: 'regionInfo.regionName',
                disableGlobalFilter: false,
            },
            {
                Header: 'Emirates',
                accessor: 'regionAreaInfo.emiratesName',
                disableGlobalFilter: false,
            },
            {
                Header: 'Area',
                accessor: 'regionAreaInfo.territoryName',
                disableGlobalFilter: false,
            },
            // {
            //     Header: 'Action',
            //     accessor: 'remove',
            //     Cell: row => (
            //         <div className="icon-style" style={{ position: "absolute" }}>
            //             <Tooltip title="Click here to view the Territory Areas">
            //                 <DeleteIcon style={{ cursor: "pointer" }} onClick={() => delete(row.row.original)} />
            //             </Tooltip>
            //         </div>
            //     ),
            // },
        ],
        [],
    );
    if (isRedirect) {
        return <Redirect to="/web_app/pnd_territory/view" />;
    }

    const Add = () => {
        setViewDetailPopup(true);
        setTitle("Add - Delivery Territory Details");
    }
    const getAllTerritoryRegionAreaDetails = async () => {
        try {
            setLoading(true);
            const response = await PndRestApi.GetAllTerritoryRegionAreaDetails(regionId);
            if (response.status === 200 && response.data.status === 200) {
                setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
            } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
                setNoRecordFound(true);
            } else {

                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data?.message}`,
                );
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };


    // const delete = async (event) => {
    //     if (event.regionId) {
    //         //getAllTerritoryRegionAreaDetails(event.regionId);
    //         //  setViewAreaPopup(true);
    //     }
    // }
    return (
        <Container>
            {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
            <h3>Area Information</h3>


            <Tooltip title="Click here to add more Areas">
                <Fab size="large" color="primary" aria-label="add" style={{ float: "right", backgroundColor: "#32CA73", color: "white" }} onClick={() => Add()}>
                    <AddIcon />
                </Fab>
            </Tooltip>

            <Fab size="large" color="primary" aria-label="add" style={{ float: "right" }} onClick={() => back()}>
                <ArrowBackIcon />
            </Fab>
            {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null && !isNoRecordFound) &&
                <ReactTableBase
                    name={t('instution_type.view.name_map')}
                    key={'searchable'}
                    columns={reactTableData.tableHeaderData}
                    data={reactTableData.tableRowsData}
                    tableConfig={tableConfig} />
            }

            {viewDetailPopup &&
                <TerritoryAreaModal
                    modalShow={viewDetailPopup}
                    setModalShow={setViewDetailPopup}
                    dataInfo={reactTableData?.tableRowsData}
                    isTitle={isTitle} />}
        </Container>

    );
};


TerritoryRegionsListView.propTypes = {
    TerritoryRegionsListView: PropTypes.func.isRequired,
};


const mapStateToProps = () => {
    return {};
};

export default connect(mapStateToProps)(reduxForm({ form: 'TerritoryRegionsListViewForm', enableReinitialize: true })(TerritoryRegionsListView))